import { http, HttpResponse } from 'msw';
import { API, BASE_URL_V3 } from '../../../src/common/constants';
import type { GetChargingStationApiResponse } from '../../../src/store/facade/facadeApiV3';
import { chargePointData5, chargePointData6 } from '../data/chargePointDataMock';

export const URL = `${BASE_URL_V3}${API.endpoints.chargingStations}${API.endpoints.details}/:id`;

let count = 0;

export const ChargingStationByIdResource = http.get(URL, () => {
    let item: GetChargingStationApiResponse;

    if (count++ % 2 === 0) {
        item = chargePointData5;
    } else {
        item = chargePointData6;
    }

    return HttpResponse.json(item);
});

export const ChargingStationByIdWithoutOpeningHours = http.get(URL, () => {
    const { openingHours, ...stationWithoutOpeningHours } = chargePointData5;
    return HttpResponse.json(stationWithoutOpeningHours);
});

export default ChargingStationByIdResource;
